import { render, staticRenderFns } from "./ToCustomer.vue?vue&type=template&id=d9f21aa0&"
import script from "./ToCustomer.vue?vue&type=script&lang=js&"
export * from "./ToCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports